
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Draggable from 'vuedraggable'
import MaterialSelect from '@/components/material-select/index.vue'

@Component({
    components: {
        Draggable,
        MaterialSelect
    }
})
export default class Attrs extends Vue {
    @Prop() value: any
    @Prop({ default: 0 }) model_id!: number
    title = ''
    // list: any = [];
    attrItemName = ''
    galleryShow = false
    attrIndex = 0
    attrItemIndex = 0
    imageIndex = 0

    colorList: any = []
    materialList: any = []
    designPartsList: any = []

    list: any = []
    @Watch('value') valueChange(value: any) {
        this.list = typeof value === 'string' ? JSON.parse(value) : value
    }

    addAttrItem() {
        this.list.push({
            id: '',
            name: '',
            source: 2,
            attr_list: [
                {
                    id: '',
                    value: '',
                    price: '',
                    weight: ''
                }
            ]
        })
    }

  
    //
    removeAttrItem(index: number) {
        this.list.splice(index, 1)
    }

    selectColor(event: any, row: any) {
        const value = this.colorList.find((color: any) => color.id == event)
        row.color = value.color
        row.zh_cn_name = value.zh_cn_name
        row.en_name = value.en_name
    }

    selectMaterial(event: any, row: any) {
        const value = this.materialList.find((material: any) => material.id == event)
        row.image = value.image
        row.zh_cn_name = value.zh_cn_name
        row.en_name = value.en_name
    }

    checkValue(index: number, sindex: number) {
        const value = this.list[index].attr_list[sindex].value
        this.list[index].attr_list.forEach((item: any, idx: number) => {
            if (item.value && sindex != idx && item.value == value) {
                this.list[index].attr_list[sindex].value = ''
                this.$message({
                    message: '已存在相同规格值',
                    type: 'warning'
                })
            }
        })
    }

    addAttrValue(index: number) {
        this.list[index].attr_list.push({
            id: '',
            value: ''
        })
    }

    removeAttrValue(index: number, sindex: number) {
        this.list[index].attr_list.splice(sindex, 1)
    }
    handleChange() {
        this.$emit('input', this.list)
    }
    mounted() {}
}
